"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEIDLinkRequired = exports.getEIDProviderName = exports.getDefaultVatRate = exports.getCurrencySymbol = exports.CurrencySymbol = exports.getCountryName = exports.getCountryNames = exports.CountryLabels = exports.getCountryIds = exports.getCountryFlag = exports.Countries = void 0;
var se_jpg_1 = __importDefault(require("../assets/img/se.jpg"));
var dk_jpg_1 = __importDefault(require("../assets/img/dk.jpg"));
var fi_jpg_1 = __importDefault(require("../assets/img/fi.jpg"));
var no_jpg_1 = __importDefault(require("../assets/img/no.jpg"));
var Countries;
(function (Countries) {
    Countries["SE"] = "SE";
    Countries["DK"] = "DK";
    Countries["NO"] = "NO";
    Countries["FI"] = "FI";
})(Countries = exports.Countries || (exports.Countries = {}));
var getCountryFlag = function (countryCode) {
    switch (countryCode) {
        case Countries.SE:
            return se_jpg_1.default;
        case Countries.DK:
            return dk_jpg_1.default;
        case Countries.FI:
            return fi_jpg_1.default;
        case Countries.NO:
            return no_jpg_1.default;
        default:
            return null;
    }
};
exports.getCountryFlag = getCountryFlag;
var getCountryIds = function () {
    var countryIds = [];
    Object.keys(Countries).forEach(function (countryId) {
        countryIds.push(Countries[countryId]);
        return null;
    });
    return countryIds;
};
exports.getCountryIds = getCountryIds;
var CountryLabels = /** @class */ (function () {
    function CountryLabels() {
        this.labels = {};
        // this.labels[Countries.SE] = getText('countries.sweden')
        // this.labels[Countries.DK] = getText('countries.denmark')
        // this.labels[Countries.NO] = getText('countries.norway')
        // this.labels[Countries.FI] = getText('countries.finland')
    }
    return CountryLabels;
}());
exports.CountryLabels = CountryLabels;
var getCountryNames = function () {
    var countryNames = [];
    var countryLabels = new CountryLabels();
    Object.keys(Countries).forEach(function (countryId) {
        countryNames.push(countryLabels.labels[countryId]);
        return null;
    });
    return countryNames;
};
exports.getCountryNames = getCountryNames;
var getCountryName = function (id) {
    var countryIds = Object.keys(Countries);
    var countryLabels = new CountryLabels();
    for (var i = 0; i < countryIds.length; i += 1) {
        if (countryIds[i] === id) {
            return countryLabels.labels[countryIds[i]];
        }
    }
    return null;
};
exports.getCountryName = getCountryName;
var CurrencySymbol = /** @class */ (function () {
    function CurrencySymbol(_a) {
        var _b = _a.prefix, prefix = _b === void 0 ? '' : _b, _c = _a.suffix, suffix = _c === void 0 ? '' : _c;
        this.prefix = prefix;
        this.suffix = suffix;
    }
    CurrencySymbol.prototype.wrap = function (value) {
        return [this.prefix, value, this.suffix].filter(function (v) { return !!v; }).join(' ');
    };
    CurrencySymbol.prototype.wrapRange = function (from, to) {
        return this.wrap("".concat(from, "\u2013").concat(to));
    };
    CurrencySymbol.prototype.toString = function () {
        return this.prefix || this.suffix;
    };
    return CurrencySymbol;
}());
exports.CurrencySymbol = CurrencySymbol;
var getCurrencySymbol = function (country) {
    switch (country) {
        case Countries.FI:
            return new CurrencySymbol({ suffix: '€' });
        case Countries.DK:
            return new CurrencySymbol({ suffix: 'kr.' });
        case Countries.SE:
        case Countries.NO:
        default:
            return new CurrencySymbol({ suffix: 'kr' });
    }
};
exports.getCurrencySymbol = getCurrencySymbol;
var getDefaultVatRate = function (country) {
    switch (country) {
        case Countries.FI:
            return 0.24;
        case Countries.SE:
        case Countries.DK:
        case Countries.NO:
        default:
            return 0.25;
    }
};
exports.getDefaultVatRate = getDefaultVatRate;
var getEIDProviderName = function (country) {
    switch (country) {
        case Countries.FI:
            return 'Tupas';
        case Countries.DK:
            return 'NemID';
        case Countries.SE:
            return 'BankID';
        case Countries.NO:
            return 'BankID';
        default:
            return 'BankID';
    }
};
exports.getEIDProviderName = getEIDProviderName;
var isEIDLinkRequired = function (country) {
    switch (country) {
        case Countries.FI:
        case Countries.DK:
            return true;
        case Countries.SE:
        case Countries.NO:
        default:
            return false;
    }
};
exports.isEIDLinkRequired = isEIDLinkRequired;
